import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';

import { Actions } from '../actions/student-actions';
import { StudentActions } from '../constants';
import { IStudent } from 'src/types/student';

export interface StudentState {
    inProgress: boolean;
    authCode: string;
    error: string;
    miniLoaderFor: { [key: string]: boolean };
    data: Paginated<IStudent>;
    current: IStudent | null;
    currentFiles: any | null;
    currentIntakes: any | null;
    inProgressIntake: boolean | null;
}

const initialState = {
    inProgress: false,
    inProgressIntake: false,
    authCode: '',
    miniLoaderFor: {},
    error: '',
    data: {
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
        inProgress: false,
    },
    current: null,
    currentFiles: null,
    currentIntakes: null,
};

export function students(state: StudentState = initialState, action: Actions | any): StudentState {
    switch (action.type) {
        case requestType(StudentActions.PERSIST_STUDENT):
            return { ...state, error: '', inProgress: true };
        case successType(StudentActions.PERSIST_STUDENT):
            return { ...state, inProgress: false };
        case failureType(StudentActions.PERSIST_STUDENT):
            return { ...state, error: action.error, inProgress: false };

        case requestType(StudentActions.FETCH_STUDENTS):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    page: 1,
                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                              updatedAt: null,
                          },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(StudentActions.FETCH_STUDENTS):
            return { ...state, data: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(StudentActions.FETCH_STUDENTS):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };

        case requestType(StudentActions.FETCH_STUDENTS_SIMPLY):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    page: 1,
                    meta: state.data?.meta,
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(StudentActions.FETCH_STUDENTS_SIMPLY):
            return { ...state, data: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(StudentActions.FETCH_STUDENTS_SIMPLY):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };

        case requestType(StudentActions.FETCH_STUDENT):
            return { ...state, inProgress: true, current: null, error: '' };
        case successType(StudentActions.FETCH_STUDENT):
            return { ...state, inProgress: false, current: action.payload };
        case failureType(StudentActions.FETCH_STUDENT):
            return { ...state, inProgress: false, error: action.error };
        case requestType(StudentActions.DELETE_STUDENT):
            return { ...state, error: '', inProgress: true };
        case successType(StudentActions.DELETE_STUDENT):
            return {
                ...state,
                inProgress: false,
                data: {
                    ...state.data,
                    list: state.data.list.filter((user: IStudent) => {
                        return user.id !== action.payload.id;
                    }),
                    meta: {
                        updatedAt: 0,
                    },
                },
            };

        case failureType(StudentActions.DELETE_STUDENT):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };

        case requestType(StudentActions.FETCH_FILES_STUDENT):
            return { ...state, error: '', inProgress: true };
        case successType(StudentActions.FETCH_FILES_STUDENT):
            return { ...state, inProgress: false, currentFiles: action.payload };
        case failureType(StudentActions.FETCH_FILES_STUDENT):
            return { ...state, inProgress: false, error: action.error };

        case requestType(StudentActions.FETCH_INTAKES_STUDENT):
            return { ...state, error: '', inProgress: true, inProgressIntake: true };
        case successType(StudentActions.FETCH_INTAKES_STUDENT):
            return { ...state, inProgress: false, inProgressIntake: false, currentIntakes: action.payload };
        case failureType(StudentActions.FETCH_INTAKES_STUDENT):
            return { ...state, inProgress: false, inProgressIntake: false, error: action.error };

        case requestType(StudentActions.DELETE_FILE_STUDENT):
            return { ...state, error: '', miniLoaderFor: { FILE: true } };
        case successType(StudentActions.DELETE_FILE_STUDENT):
            const { sagaPayload } = action;
            const curNewFiles = (state.currentFiles ?? []).filter((file: any) => file.id !== sagaPayload.id);

            return {
                ...state,
                miniLoaderFor: {},
                currentFiles: curNewFiles,
            };
        case failureType(StudentActions.DELETE_FILE_STUDENT):
            return { ...state, miniLoaderFor: {}, error: action.error.response.data?.errorMessage ?? 'Unknown error' };

        case requestType(StudentActions.CREATE_FILES_STUDENT):
            return { ...state, error: '', miniLoaderFor: { FILE: true } };
        case successType(StudentActions.CREATE_FILES_STUDENT):
            if (action.sagaPayload.requestType === 'ORDER') {
                return { ...state, current: action.payload, error: '', miniLoaderFor: {} };
            } else if (action.sagaPayload.requestType === 'CONSENT') {
                return { ...state, current: action.payload, error: '', miniLoaderFor: {} };
            } else if (action.sagaPayload.requestType === 'PARENT_CONSENT') {
                return { ...state, current: action.payload, error: '', miniLoaderFor: {} };
            } else {
                const curFiles = [...(state.currentFiles ?? [])];
                curFiles.push(action.payload);

                return {
                    ...state,
                    inProgress: false,
                    currentFiles: curFiles,
                    miniLoaderFor: {},
                };
            }

        case failureType(StudentActions.CREATE_FILES_STUDENT):
            return { ...state, miniLoaderFor: {}, error: action.error.response.data?.errorMessage ?? 'Unknown error' };


        /*case requestType(StudentActions.CREATE_INTAKE_STUDENT):
            return { ...state, error: '', miniLoaderFor: { FILE: true } };
        case successType(StudentActions.CREATE_INTAKE_STUDENT):
            return { ...state, current: action.payload, error: '', miniLoaderFor: {} };
        case failureType(StudentActions.CREATE_INTAKE_STUDENT):
            return { ...state, miniLoaderFor: {}, error: action.error.response.data?.errorMessage ?? 'Unknown error' };
*/

        default:
            return state;
    }
}
